import React from 'react';

import { checkIfHotjarEnable } from '../../../utils/helpers';
import DropFileInput from '../../common/DropFileInput/DropFileInput';
import IconEye from '../../../assets/ic_eye_blue.svg';
import IconCheck from '../../../assets/ic_check_green.svg';

const FileAttachComp = ({
  title,
  customClass,
  description,
  docUrl,
  typeFile,
  typeFileId,
  currentFiles,
  maxFiles,
  onLoadFile,
  onDeleteFile,
  onShowExample
}) => {
  const onDetalleClick = () => {
    if (onShowExample) {
      onShowExample(title)
    } else {
      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          action: {
            group: 'Tramites Siniestros - Protección Tarjeta BBVA',
            category: 'Adjunta documentos',
            name: 'Ver ejemplo',
            label: title,
          },
          event: 'trackAction',
        });
      }
    }
  };

  console.log(currentFiles);

  return (
    <div className={`fileAttachComp ${customClass}`}>
      <div className="fileAttachComp__top">
        <h3 className="title">{title}</h3>
        {
          !currentFiles?.files?.length ? (
            <a
              className="link"
              href={docUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onDetalleClick}
            >
              <img src={IconEye} alt="descarga un ejemplo aquí" />
              <p>Ver ejemplo</p>
            </a>
          ) : <img className='checkIcon' src={IconCheck} alt="archivos cargados" />
        }
      </div>
      <div className="fileAttachComp__info">{description}</div>

      <DropFileInput
        title={title}
        typeFile={typeFile}
        typeFileId={typeFileId}
        currentFiles={currentFiles}
        maxFiles={maxFiles}
        onLoadFile={onLoadFile}
        onDeleteFile={onDeleteFile}
      />
    </div>
  );
};

export default FileAttachComp;
